import { Request } from 'api';
import { AxiosResponse } from 'axios';
import type { Individual } from 'utils';

type ReturnType = Promise<AxiosResponse<Individual>>;

export function getSelfIndividual(organization: string): ReturnType {
    return Request.get(`/individuals/self`, { params: { organization } });
}
